import { BitfStrapiModel } from '@common/libs/bitforce/core/models/strapi/bitf-strapi.model';

export class Brand extends BitfStrapiModel {
  name: string;

  // Relations
  // vehicles: any;

  constructor(data?: any) {
    super({
      data,
      hydrateProperties: {
        // start_date: { model: Date },
      },
      serializeProperties: [],
    });
  }
}
